"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteNotificationLocally = deleteNotificationLocally;
exports.markAsViewedLocally = markAsViewedLocally;
exports.undoDeleteLocally = undoDeleteLocally;
function getNotificationsOrDefault(notifications) {
  return notifications ?? {
    newNotificationsCount: 0,
    notifications: {
      new: [],
      earlier: []
    }
  };
}
function deleteNotificationLocally(localNotifications, notificationId) {
  const notifications = getNotificationsOrDefault(localNotifications);
  return {
    newNotificationsCount: notifications.newNotificationsCount - 1,
    notifications: {
      new: notifications.notifications.new.filter(n => n.notificationId !== notificationId),
      earlier: notifications.notifications.earlier.filter(n => n.notificationId !== notificationId)
    }
  };
}
function markAsViewedLocally(localNotifications, notificationId) {
  const notifications = getNotificationsOrDefault(localNotifications);
  return {
    newNotificationsCount: notifications.newNotificationsCount,
    notifications: {
      new: notifications.notifications.new.map(n => ({
        ...n,
        isViewed: n.notificationId === notificationId ? true : n.isViewed
      })),
      earlier: notifications.notifications.earlier.map(n => ({
        ...n,
        isViewed: n.notificationId === notificationId ? true : n.isViewed
      }))
    }
  };
}
function insertToArray(array, index, newItem) {
  return [...array.slice(0, index), newItem, ...array.slice(index)];
}
function undoDeleteLocally({
  localNotifications,
  notification,
  index,
  section
}) {
  const notifications = getNotificationsOrDefault(localNotifications);
  return {
    newNotificationsCount: notifications.newNotificationsCount + 1,
    notifications: {
      new: section === 'new' ? insertToArray(notifications.notifications.new, index, notification) : notifications.notifications.new,
      earlier: section === 'earlier' ? insertToArray(notifications.notifications.earlier, index, notification) : notifications.notifications.earlier
    }
  };
}
